// extracted by mini-css-extract-plugin
export default {"zoomModal":"y1-z"};